import { useContext } from 'react';
import Context from './context';

export default function useZonesContext() {
  const context = useContext(Context);
  return context;
}
